import { Component, Input } from '@angular/core';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { CurrencyPipe } from '@angular/common';
import { Chart } from 'chart.js';
import { ICostCenterReport, IReport } from '../../../../interfaces/reports';
import * as moment from 'moment';

@Component({
  selector: 'economy-view',
  templateUrl: './economy-view.component.html',
  styleUrls: ['../../reports.component.scss', './economy-view.component.scss'],
  providers: [CurrencyPipe]
})
export class EconomyViewComponent {

  @Input() reports: IReport[];

  @Input() set selectedGroups(groups: string | string[]) {
    this.groups = groups;
    this.currentGroupData = this.getCurrentGroupData(0);
    this.updateDataTable();
  }

  economyChart;
  rows: any = [];
  chartRows: any = [];
  groups: string | string[] = 'all';
  columnModes = ColumnMode;
  currentGroupData: ICostCenterReport;

  columnsCoupons = [
    { prop: 'period', name: 'Período', flexGrow: 2 },
    { prop: 'coupons_uniq_users', name: 'Pessoas únicas', flexGrow: 1 },
    { prop: 'coupons', name: 'Cupons Gerados', flexGrow: 1 },
    { prop: 'couponLaunchedEconomy', name: 'Economia Gerada', flexGrow: 1 }
  ];

  columnsTickets = [
    { prop: 'period', name: 'Período', flexGrow: 2 },
    { prop: 'cinema_unique_users', name: 'Pessoas únicas', flexGrow: 1 },
    { prop: 'cinema_tickets', name: 'Ingressos Vendidos', flexGrow: 1 },
    { prop: 'cinema_value', name: 'Economia Gerada', flexGrow: 1 }
  ];

  constructor(private currencyPipe: CurrencyPipe) {}

  getCurrentGroupData(index = 0): ICostCenterReport {
    if (this.groups === 'all') {
      const report = this.reports[index].data_by_cost_center.find(el => el.costCenter === 'all') || {};
      return { ...report, launchedEconomy: (report.couponLaunchedEconomy + report.cinema_value) || 0 };
    } else {
      const report = this.reports[index].data_by_cost_center.filter(el => this.groups.includes(el.costCenter));
      return this.sumGroups(report);
    }
  }

  updateDataTable() {
    this.chartRows = this.reports.map((el, index) => {
      const groupReport = this.getCurrentGroupData(index);
      return { ...groupReport, period: moment.utc(el.date).format('MMM/YY') };
    });

    this.rows = this.reports.map((el, index) => {
      const groupReport = this.getCurrentGroupData(index);

      return {
        ...groupReport,
        period: moment.utc(el.date).format('MMM/YY'),
        coupons: groupReport.coupons || '-',
        coupons_uniq_users: groupReport.coupons_uniq_users || '-',
        couponLaunchedEconomy: groupReport && this.formatCurrency(groupReport.couponLaunchedEconomy) || '-',
        cinema_tickets: groupReport.cinema_tickets || '-',
        cinema_value: groupReport &&  this.formatCurrency(groupReport.cinema_value) || '-',
        cinema_unique_users: groupReport && groupReport.cinema_unique_users || '-',
      };
    });

    this.updateChart();
  }

  formatCurrency(value) {
    try {
      return this.currencyPipe.transform(value, 'BRL', 'symbol', '1.2-2');
    } catch (e) {
      return '-';
    }
  }

  sumGroups = (groups) => {
    const fieldsToSum = ['registered', 'adhered', 'use', 'potentialEconomy', 'couponLaunchedEconomy', 'cinema_value',
      'coupons', 'launchedEconomy', 'cinema_unique_users', 'cinema_tickets'];

    const groupsSum = groups.reduce((a, b) => {
      const element = {};
      fieldsToSum.forEach(el => {element[el] = (a ? (a[el] || 0) : 0) + (b ? (b[el] || 0) : 0); });
      return element;
    }, {});

    return {
      ...groupsSum,
      launchedEconomy: (groupsSum.couponLaunchedEconomy + groupsSum.cinema_value) || 0,
      adhered_registered: groupsSum.adhered / groupsSum.registered,
      use_registered: groupsSum.use / groupsSum.registered,
      use_adhered: groupsSum.use / groupsSum.adhered
    };
  };

  updateChart() {
    if (this.economyChart) {
      this.economyChart.data.datasets = [{
        label: 'Cupons',
        backgroundColor: 'rgba(156, 0, 83, 1)',
        data: this.chartRows.map(el => el.couponLaunchedEconomy).reverse(),
      }, {
        label: 'Cinema',
        backgroundColor: 'rgba(208, 0, 111, 1)',
        data: this.chartRows.map(el => el.cinema_value).reverse(),
      }];

      this.economyChart.update();
    } else {
      this.initChart();
      this.updateChart();
    }
  }

  initChart() {
    this.economyChart = new Chart('economyChart', {
      type: 'bar',
      data: {
        labels: this.chartRows.map(el => el.period).reverse(),
        datasets: []
      },
      options: {
        responsive: true,
        scales: {
          xAxes: [{
            stacked: true,
          }],
          yAxes: [{
            stacked: true
          }]
        }
      },
    });
  }
}
